"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urlLib = require("url-lib");

var _cookiesJs = _interopRequireDefault(require("cookies-js"));

var _http = require("js-utils/http");

var _path = require("js-utils/path");

var _Button = _interopRequireDefault(require("eventbrite_design_system/button/Button"));

var _constants = require("eventbrite_design_system/button/constants");

var _Avatar = _interopRequireDefault(require("eventbrite_design_system/avatar/Avatar"));

var _Modal = _interopRequireDefault(require("eventbrite_design_system/modal/Modal"));

var _withLoginModalControls = _interopRequireDefault(require("../HOC/withLoginModalControls"));

var _constants2 = require("../constants");

var _RandomSuperCrop = _interopRequireDefault(require("./RandomSuperCrop"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ModalContent = function ModalContent(_ref) {
  var onGetStarted = _ref.onGetStarted,
      organizerName = _ref.organizerName,
      organizerProfilePicture = _ref.organizerProfilePicture,
      organizerId = _ref.organizerId;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "eds-g-cell eds-g-cell-1-1 eds-g-cell--has-overflow"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "eds-align--center-horizontal eds-l-mar-top-8"
  }, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
    imageUrl: organizerProfilePicture,
    iconType: /*#__PURE__*/_react.default.createElement(_RandomSuperCrop.default, {
      id: organizerId
    }),
    backgroundColor: "grey-100"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "eds-align--center-horizontal eds-l-mar-top-8"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "eds-text-hs"
  }, (0, _constants2.followLoginModalTitleText)(organizerName))), /*#__PURE__*/_react.default.createElement("div", {
    className: "eds-align--center-horizontal eds-l-mar-top-8"
  }, /*#__PURE__*/_react.default.createElement("span", null, _constants2.FOLLOW_LOGIN_MODAL_SUBTITLE_TEXT)), /*#__PURE__*/_react.default.createElement("div", {
    className: "eds-align--center-horizontal eds-l-mar-top-8"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    style: _constants.STYLE_FILL,
    onClick: onGetStarted
  }, _constants2.GET_STARTED_TEXT)));
};

var FollowLoginModal = /*#__PURE__*/function (_Component) {
  _inherits(FollowLoginModal, _Component);

  var _super = _createSuper(FollowLoginModal);

  function FollowLoginModal() {
    var _this;

    _classCallCheck(this, FollowLoginModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_handleOnGetStarted", function () {
      _this.props.trackGAEvent({
        action: _constants2.LOGIN_MODAL_ACCEPT_GA_ACTION,
        category: _constants2.LOGIN_MODAL_CATEGORY,
        label: _this.props.organizerName
      });

      _this._saveOrganizerInfoInCookie();

      _this._redirectToSignIn();
    });

    _defineProperty(_assertThisInitialized(_this), "_redirectToSignIn", function () {
      var _this$props = _this.props,
          referrer = _this$props.referrer,
          shouldOpenNewTab = _this$props.shouldOpenNewTab; // then redirect to sign-in page, stld activates the "sticky TLD" feature
      // of the sign-in flow that will not redirect to the user's preferred TLD.

      var formattedUrl = (0, _urlLib.formatUrl)('/signin/', {
        referrer: referrer,
        stld: 1
      });

      if (shouldOpenNewTab) {
        return window.open(formattedUrl);
      }

      return (0, _http.setWindowLocation)(formattedUrl);
    });

    _defineProperty(_assertThisInitialized(_this), "_saveOrganizerInfoInCookie", function () {
      var organizerId = _this.props.organizerId;

      _cookiesJs.default.set(_constants2.ORGANIZER_COOKIE, organizerId, {
        path: (0, _path.getUrlPath)(),
        secure: true,
        expires: 300
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleOnCloseModal", function () {
      _this.props.trackGAEvent({
        action: _constants2.LOGIN_MODAL_REJECT_GA_ACTION,
        category: _constants2.LOGIN_MODAL_CATEGORY,
        label: _this.props.organizerName
      });

      _this.props.onCloseModal();
    });

    return _this;
  }

  _createClass(FollowLoginModal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          organizerName = _this$props2.organizerName,
          organizerProfilePicture = _this$props2.organizerProfilePicture,
          isModalShown = _this$props2.isModalShown,
          organizerId = _this$props2.organizerId;
      return /*#__PURE__*/_react.default.createElement(_Modal.default, {
        isShown: isModalShown,
        onClose: this._handleOnCloseModal
      }, /*#__PURE__*/_react.default.createElement(ModalContent, {
        onGetStarted: this._handleOnGetStarted,
        organizerName: organizerName,
        organizerProfilePicture: organizerProfilePicture,
        organizerId: organizerId
      }));
    }
  }]);

  return FollowLoginModal;
}(_react.Component);

_defineProperty(FollowLoginModal, "propTypes", {
  organizerId: _propTypes.default.string.isRequired,
  organizerName: _propTypes.default.string.isRequired,
  onCloseModal: _propTypes.default.func.isRequired,
  trackGAEvent: _propTypes.default.func.isRequired,
  organizerProfilePicture: _propTypes.default.string.isRequired,
  isModalShown: _propTypes.default.bool.isRequired,
  referrer: _propTypes.default.string,
  shouldOpenNewTab: _propTypes.default.bool
});

_defineProperty(FollowLoginModal, "defaultProps", {
  referrer: (0, _path.getUrlPath)() || '',
  shouldOpenNewTab: false
});

var _default = (0, _withLoginModalControls.default)(FollowLoginModal);

exports.default = _default;